import {getStorage, removeStorage, setStorage} from "./index";

const TOKEN_KEY = 'login_token'

/**
 * 获取 token
 * @returns {string}
 */
export const getToken = () => getStorage(TOKEN_KEY)

/**
 * 设置 token
 * @param token
 */
export const setToken = token => setStorage(TOKEN_KEY, token)

/**
 * 删除token
 * @returns {*}
 */
export const removeToken = () => removeStorage(TOKEN_KEY)

/**
 * 判断是否登录
 * @returns {boolean}
 */
export const Auth = () => !!getStorage('user')
